// Styles
import './EnergeticsDetail.scss';

// Libs
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import ExternalLink from '@/common/components/atoms/ExternalLink/ExternalLink';
// Blocks
import EnergyClass from '@/ebat/components/blocks/Product/EnergyClass/EnergyClass';

import {
  EnergeticsDetailDefaultProps,
  EnergeticsDetailPropTypes,
} from './EnergeticsDetail.proptypes';

const EnergeticsDetail = ({ energyClasses, links }) => {
  const { t } = useTranslation();

  const hasMultipleLinks = useMemo(() => links.length > 1, [links]);

  return (
    <>
      <h1 className="rs-modal-title">
        {t('ebat:entities:product.details.energetics.plural')}
      </h1>
      <p className="modal-subtitle">
        {t('ebat:entities:product.details.energetics.subtitle')}
      </p>
      <ul className="list list--energetics" data-qa-id="list-energetics">
        {energyClasses.map((energyClass, index) => (
          <li key={`energy-class-${index}`} className="list__item">
            <EnergyClass label={energyClass.label} score={energyClass.score} />
          </li>
        ))}
      </ul>
      <ul className="list list--links" data-qa-id="list-links">
        {links.map((link, index) => (
          <li key={`link-${index}`} className="list__item">
            <ExternalLink href={link} className="energetics-link">
              {`${t('ebat:entities:product.details.energetics.link')}${
                hasMultipleLinks ? ` ${index + 1}` : ''
              }`}
            </ExternalLink>
          </li>
        ))}
      </ul>
    </>
  );
};

EnergeticsDetail.defaultProps = {
  ...EnergeticsDetailDefaultProps,
};

EnergeticsDetail.propTypes = {
  ...EnergeticsDetailPropTypes,
};

export default EnergeticsDetail;
